// extracted by mini-css-extract-plugin
export default {"positioning":"positioning__zkod_fVPryP0","positioning-3-column-view":"positioning-3-column-view__uj70mboD9q3q","kbSearch":"kbSearch__kX3iG2VyPcyf"};